export default __webpack_public_path__ + "static/media/marketing.0ae85415.svg";